import fetch from 'cross-fetch';
import { useContext, createContext, Context } from 'react';
import { AddressValidationContext, AddressValidationApiUtil, AddressValidationApiResponse } from '../@types';
import { getMappedCountryData } from './utils';

export const addressValidateContext: Context<AddressValidationContext> = createContext<AddressValidationContext>({
    countries: {},
    setCountries: () => {},
    countryList: [],
});

export const useAddressValidateContext = () => {
    return useContext(addressValidateContext);
};

// todo: move this to @ynap/api-utils
export const addressValidation: AddressValidationApiUtil = async (params) => {
    try {
        const { config, countryCode, countries } = params;
        const division = config.head.division;
        const baseUrl = config.global.services.addressValidation.baseUrl;
        const url = `${baseUrl}api/address_validation/v1/${division}/countries/${countryCode}.json`;

        const response = await fetch(url);

        const responseJson: AddressValidationApiResponse = await response.json();
        if (response.status >= 400) {
            throw new Error(`addressValidation: Address Validation API error: ${response.url}`);
        }

        const countryData = responseJson.countries;
        return getMappedCountryData(countryData, countries);
    } catch (err) {
        console.log(err);
        throw err;
    }
};
